<!--
 * @Author: lbh
 * @Date: 2022-06-24 11:48:36
 * @LastEditors: lbh
 * @LastEditTime: 2023-08-31 16:26:22
 * @Description: 图片
-->
<template>
  <div class="self-image-box">
    <van-image
      :fit="fit"
      style="width: 100%; height: 100%"
      :radius="radius"
      :src="$util.getImageUrl(src)"
      @click="onClickImg"
    >
      <template v-slot:loading>
        <van-loading type="spinner" size="20" />
      </template>
      <template v-slot:error>
        <img style="width: 100%; height: 100%" :src="defaultImg" />
      </template>
    </van-image>
    <slot name="content"></slot>
  </div>
</template>
<script>
export default {
  name: "self-image",
  props: {
    src: {
      default() {
        return "";
      },
    },
    fit: {
      default() {
        return "fill";
      },
    },
    radius: {
      default() {
        return "0";
      },
    },
    defaultImg: {
      default: require("../../assets/default/small_default.png"),
    },
  },
  methods: {
    onClickImg() {
      this.$emit("click", this.isError);
    },
  },
};
</script>

<style lang="less" scoped>
.self-image-box {
  width: 100%;
  height: 100%;
  & /deep/ .van-image {
    vertical-align: middle;
    .van-image__error,
    .van-image__loading {
      background-color: rgb(229, 229, 229);
      width: 100%;
      height: 100%;
      img {
        object-fit: contain;
      }
    }
  }
}
</style>
